<template>
    <b-button-group :size="size">
        <b-button :variant="variant" @click="$emit('selected', id)">
            <slot v-if="$slots.default"></slot>
            <template v-else>{{text}}</template>
        </b-button>
        <b-button size="sm" :variant="variant" v-if="removable" @click="$emit('removed', id)" class="btn-remove">
            <i class="fas fa-times"></i>
        </b-button>
    </b-button-group>
</template>

<script>
    export default {
        name: "Tag",
        props: {
            id: {
                type: String,
                default: null
            },
            text: {
                type: String,
                default: ''
            },
            size: {
                type: String,
                default: ''
            },
            removable: {
                type: Boolean,
                default: true
            },
            variant: {
                type: String,
                default: 'primary'
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/variables/variables";

    .btn-remove{
        &:hover,
        &:focus{
            background: $red !important;
        }
    }
</style>